import { render, staticRenderFns } from "./Fines.vue?vue&type=template&id=a4c8d9aa&scoped=true"
import script from "./Fines.vue?vue&type=script&lang=js"
export * from "./Fines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c8d9aa",
  null
  
)

export default component.exports